import minicart from './minicart';
import util from './util';
import opcStore from '@osfonepagecheckout/src/store';

let eventHandlersAttached = false;
export default {
    attachEventHandlers() {
        if (!eventHandlersAttached) {
            window.addEventListener('click', event => {
                if (event.target.classList && event.target.classList.contains('dynamic-promo__product-add-to-cart-cta')) {
                    const productId = event.target.closest('.dynamic-promo').dataset.productId;
                    const productQty = event.target.closest('.dynamic-promo').dataset.productQty;
                    const request = new XMLHttpRequest();
                    const formData = new FormData();
                    const isOnePageCheckout = document.querySelector('body.checkout');

                    formData.append('pid', productId);
                    formData.append('qty', productQty);
                    request.open('POST', util.ajaxUrl(window.Urls.addProduct), true);
                    request.onload = () => {
                        if (request.status >= 200 && request.status < 400) {
                            minicart.updateAndShow();
                            if (isOnePageCheckout) {
                                opcStore.dispatch('getCart');
                            }
                        }
                    };
                    request.send(formData);
                }
            });
            eventHandlersAttached = true;
        }
    },
    init() {
        this.attachEventHandlers();
    }
};
